import { render, staticRenderFns } from "./JobsProfileDetail.vue?vue&type=template&id=5f5adb65&scoped=true&"
import script from "./JobsProfileDetail.vue?vue&type=script&lang=js&"
export * from "./JobsProfileDetail.vue?vue&type=script&lang=js&"
import style0 from "./JobsProfileDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./JobsProfileDetail.vue?vue&type=style&index=1&id=5f5adb65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5adb65",
  null
  
)

export default component.exports